module.exports = __webpack_public_path__ + "media/images/icon__facebook@2x-3b11bdd40acc3262c81686eaa55c35bd.png";